export const constructAddressData = (values) => {
  return {
    address: values.shippingAddress + (values.shippingAppartment ? " " + values.shippingAppartment : ""),
    country: values.shippingCountry,
    city: values.shippingCity,
    state: values.shippingState,
    zipcode: values.shippingZipCode,
  };
};
